import { CSSResultGroup, TemplateResult, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { OutlineAccordion } from 'src/components/base/outline-accordion/outline-accordion';
import '../idb-heading/idb-heading';
import '../../base/outline-container/outline-container';
import componentStyles from './idb-accordion.css.lit';
import { SlotController } from '../../controllers/slot-controller';

/**
 * The IdbAccordion component
 * @element idb-accordion
 */
@customElement('idb-accordion')
export class IdbAccordion extends OutlineAccordion {
  static styles: CSSResultGroup = [componentStyles];
  slots = new SlotController(this, false);

  @property({ type: Boolean, attribute: 'condensed' })
  condensed = false;

  @property({ type: Boolean, attribute: 'full-bleed' })
  fullBleed = false;

  @state() hasEyebrow: boolean;
  @state() hasHeading: boolean;
  @state() hasSubheading: boolean;

  useHeaderSection = false;

  connectedCallback(): void {
    super.connectedCallback();
    this.singlePanel = false;
    this.clean = true;
  }

  firstUpdated() {
    this.hasEyebrow = this.slots.test('eyebrow');
    this.hasHeading = this.slots.test('heading');
    this.hasSubheading = this.slots.test('subheading');
    this.useHeaderSection =
      this.hasEyebrow || this.hasHeading || this.hasSubheading;
  }

  render(): TemplateResult {
    return html`
    <div class="wrapper">
      <outline-container ?full-bleed="${this.fullBleed}" ?x-padding="${!this
      .fullBleed}">
        ${
          this.useHeaderSection
            ? html`
          <div class="header-section ${
            this.condensed ? 'accordion-condensed' : ''
          }">
            ${
              this.hasEyebrow
                ? html`<div class="eyebrow">
              <slot name="eyebrow"></slot>
            </div>`
                : null
            }
            ${this._conditionalSlotTemplate({
              slotName: 'heading',
            })}
            ${this._conditionalSlotTemplate({
              slotName: 'subheading',
            })}
          </div>
        `
            : null
        }
        <div class="accordion ${
          this.condensed ? 'accordion-condensed' : ''
        }" @keydown=${this.handleKeyboardNav}>
          <slot name="panels"></slot>
        </div>

      </outline-container>
    </div>
    `;
  }

  updated() {
    super.updated();
    this.panels.map((panel, index) => {
      if (this.panels.length === 1) {
        panel.setAttribute('level', 'single');
      } else {
        if (index === 0) {
          panel.setAttribute('level', 'first');
        }
        if (index === this.panels.length - 1) {
          panel.setAttribute('level', 'last');
        }
      }
    });
  }
}
